import React, { FC } from 'react';
import { OkS } from '@kl/hexa-ui-icons/16';
import { StyledFlexContainer, StyledLandingContainer } from 'shared/ui/styled-components';
import { LocalizedText } from 'shared/ui/localized-text';
import { IContent } from '../../model/content';
import {
    StyledBlockContainer,
    StyledBlockWrapper,
    StyledImgWrapper,
    StyledOptionText,
} from './styled';
import { ContentHeader } from './ContentHeader';

export const ContentSection: FC<IContent> = ({
    alt,
    localizationPath,
    headerKeys,
    textKeys,
    optionKeys,
    image,
    logo,
}) => {
    return (
        <StyledLandingContainer $align="center" $justify="center" $width="100%">
            <StyledBlockContainer>
                <StyledBlockWrapper $direction="column" $width="100%">
                    <StyledLandingContainer
                        $direction="column"
                        $gap="1em"
                        $padding="0.5em 0 0 0"
                        $width="100%"
                    >
                        <ContentHeader
                            headerKeys={headerKeys}
                            localizationPath={localizationPath}
                            logo={logo}
                        />
                        {textKeys.map(textKey => (
                            <LocalizedText
                                key={textKey}
                                localizationKey={`${localizationPath}.${textKey}`}
                            />
                        ))}
                        {optionKeys &&
                            optionKeys.map(optionKey => (
                                <StyledFlexContainer key={optionKey} $gap="8px">
                                    <OkS color="#1DA189" />
                                    <StyledOptionText
                                        localizationKey={`${localizationPath}.${optionKey}`}
                                    />
                                </StyledFlexContainer>
                            ))}
                    </StyledLandingContainer>
                </StyledBlockWrapper>
                <StyledImgWrapper alt={alt} src={image} />
            </StyledBlockContainer>
        </StyledLandingContainer>
    );
};
